import React from 'react';
import DateSelector from '../libraries/DateSelector';

const WidGetDateSelect = ({ date, setDate }) => {
    return (
        <DateSelector date={date} getDate={(e) => setDate(e)} />
    );
};

export default WidGetDateSelect;
